var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11",
    "data-name": "Group 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pinterest",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pinterest-2",
    "data-name": "pinterest",
    d: "M15.941,0a15.476,15.476,0,0,0-6.2,29.666,13.784,13.784,0,0,1,.267-3.575c.321-1.281,1.978-8.43,1.978-8.43a6.247,6.247,0,0,1-.481-2.454c0-2.294,1.336-4,2.993-4a2.093,2.093,0,0,1,2.085,2.348c0,1.387-.909,3.522-1.39,5.5a2.4,2.4,0,0,0,2.459,2.988c2.94,0,4.917-3.788,4.917-8.217,0-3.415-2.3-5.923-6.467-5.923a7.357,7.357,0,0,0-7.643,7.417,4.436,4.436,0,0,0,1.015,3.041.757.757,0,0,1,.214.854c-.053.267-.267.96-.321,1.227a.549.549,0,0,1-.8.373c-2.191-.907-3.153-3.255-3.153-5.923,0-4.375,3.688-9.658,11.064-9.658,5.933,0,9.835,4.269,9.835,8.857,0,6.083-3.367,10.618-8.338,10.618a4.5,4.5,0,0,1-3.795-1.921s-.909,3.575-1.069,4.269a12.584,12.584,0,0,1-1.55,3.308,15.018,15.018,0,0,0,4.383.64,15.5,15.5,0,1,0,0-31",
    transform: "translate(-0.441)",
    fill: "#cb1f24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinterest);
export default __webpack_public_path__ + "static/media/icon_pinterest.c3d46242d99ac04279d5e89cb601c71f.svg";
export { ForwardRef as ReactComponent };